import { useQuery } from '@tanstack/react-query';
import { API } from 'network/api';
import { useSelector } from 'react-redux';

import type { TaskAPIResponse } from 'screens/task-management/types';
import { selectUserEmail } from 'store/auth/selectors';

const useTasksQuery = (queryParams?: Record<string, unknown>) => {
  const userEmail = useSelector(selectUserEmail);

  const query = useQuery<TaskAPIResponse>({
    queryKey: ['tasks', { ...queryParams, userEmail }],
    queryFn: async () => {
      const response = await API.get<TaskAPIResponse>(
        '/taskassignment/weekly/task-view',
        {
          params: { ...queryParams },
        },
      );
      return response?.data;
    },
    staleTime: 1000 * 20, // 20 seconds
  });

  return query;
};

export default useTasksQuery;
